import React, { useContext } from 'react';

import ModalContext from './ModalContext';

const Header = ({ children }) => {
  const { onDismiss, modalHeaderId } = useContext(ModalContext);
  return (
    <header className="llui-Modal-header">
      <h1 id={modalHeaderId}>{children}</h1>
      <button
        type="button"
        aria-label={t('common.close')}
        className="llui-Modal-closeButton"
        onClick={onDismiss}
      >
        &times;
      </button>
    </header>
  );
};

export default Header;
